import { required } from '@vuelidate/validators'

export const RoleValidation = {
    name: { required },
    description: { required },
    permissions: { required },
}
